module.exports = __webpack_public_path__ + "img/racers-white.9d8892d4.png";